import React from 'react';
import { useState } from 'react';
import {
  Box,
  Typography,
  IconButton,
  UserFlag,
  Paper,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  KeyboardArrowDownIcon,
  KeyboardArrowUpIcon,
} from 'src/components';
import Markdown from 'src/pages/handbook/article/markdown';

export default function CountriesSelectDropdown({ countries = [] }) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleToggle = (event) => {
    setAnchorEl(open ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (index) => {
    setSelectedIndex(index);
    handleClose();
  };

  const selectedCountry = countries[selectedIndex] || {};

  return (
    <Box sx={{ width: '100%', maxWidth: 600, mx: 'auto', mt: 2, mb: 4 }}>
      {/* Custom Select Header (menu trigger) */}
      <Paper
        onClick={handleToggle}
        onTouchStart={() => {}}
        style={{ cursor: 'pointer', touchAction: 'manipulation' }}
        sx={{
          display: 'flex',
          alignItems: 'center',
          px: 2,
          py: 1.5,
          cursor: 'pointer',
          userSelect: 'none',
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          backgroundColor: 'background.paper',
          '&:hover': { backgroundColor: 'action.hover' },
        }}
        aria-haspopup="listbox"
        aria-expanded={open}
        role="button"
        tabIndex={0}
      >
        <UserFlag countryCode={selectedCountry.flag} size={30} />
        <Typography
          variant="body1"
          fontWeight={600}
          sx={{ ml: 2, flexGrow: 1 }}
        >
          {selectedCountry.name || 'Select a country'}
        </Typography>
        <IconButton
          size="small"
          sx={{ color: 'text.secondary' }}
          aria-label={open ? 'Close country list' : 'Open country list'}
        >
          {open ? (
            <KeyboardArrowUpIcon fontSize="small" />
          ) : (
            <KeyboardArrowDownIcon fontSize="small" />
          )}
        </IconButton>
      </Paper>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        autoFocus={false}
        disableAutoFocusItem
        slotProps={{
          paper: {
            sx: {
              mt: 0.5,
              width: anchorEl ? anchorEl.offsetWidth : undefined,
              maxHeight: 300,
              borderRadius: 2,
              border: '1px solid',
              borderColor: 'divider',
            },
          },
        }}
        MenuListProps={{
          sx: { py: 0 },
        }}
      >
        {countries.map((country, index) => (
          <MenuItem
            key={country.flag}
            selected={index === selectedIndex}
            onClick={() => handleSelect(index)}
          >
            <ListItemIcon sx={{ minWidth: 40 }}>
              <UserFlag countryCode={country.flag} size={24} />
            </ListItemIcon>
            <ListItemText
              primary={country.name}
              primaryTypographyProps={{ fontWeight: 600 }}
            />
          </MenuItem>
        ))}
      </Menu>

      {/* Selected country content */}
      <Box
        sx={{
          mt: 2,
          p: 2,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          backgroundColor: 'background.default',
          minHeight: 100,
        }}
      >
        {Array.isArray(selectedCountry.content) &&
          selectedCountry.content.map((child, i) =>
            typeof child === 'string' ? (
              <Markdown key={i}>{child}</Markdown>
            ) : (
              <React.Fragment key={i}>{child}</React.Fragment>
            )
          )}
      </Box>
    </Box>
  );
}